import { render, staticRenderFns } from "./EditMenus.vue?vue&type=template&id=6d21652b"
import script from "./EditMenus.vue?vue&type=script&lang=ts"
export * from "./EditMenus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports